import {pushDataLayer} from "@/service/gtm";
import {GTM_EVENT_BUY_CREDITS_CLICK, GTM_BUTTON_BUY_CREDIT_PURCHASE} from "@/service/gtm/types";
import store from "@/store";
import {handleInsufficientFundsError} from "@/service/user";
import router from "@/router";
import {paymentFlowSource} from "@/service/payment/PaymentFlowSource";

export const requestBuyCreditsRouteHandler = async () => {

    pushDataLayer(GTM_EVENT_BUY_CREDITS_CLICK, store.state.authenticate.auth.user)
    paymentFlowSource.setItem(GTM_BUTTON_BUY_CREDIT_PURCHASE, store.state.authenticate.auth.user)

    if( ! store.state.credits.amount) {
        return await handleInsufficientFundsError()
    }

    await router.push({name: 'credits'})

}